const themeContract = {
  tu: {
    heading: {
      display: 'display-3',
      color: 'brand-1'
    },
    text: {
      mobilePadding: '',
      desktopPadding: ''
    }
  },
  argos: {
    heading: {
      display: 'display-1',
      color: 'grey-90'
    },
    text: {
      mobilePadding: '',
      desktopPadding: ''
    }
  },
  habitat: {
    heading: {
      display: 'display-2',
      color: 'brand-1'
    },
    text: {
      mobilePadding: '',
      desktopPadding: ''
    }
  },
  nectar: {
    heading: {
      display: 'display-2',
      color: 'purple-90'
    },
    text: {
      mobilePadding: '',
      desktopPadding: ''
    }
  },
  sainsburys: {
    heading: {
      display: '',
      color: 'grey-80'
    },
    text: {
      mobilePadding: 'lg',
      desktopPadding: 'xl'
    }
  }
}

export { themeContract }
